import {
  FaUserShield, FaLayerGroup, FaToolbox, FaClipboardCheck, FaCalendarCheck,
  FaStore, FaUsers, FaHardHat,
} from 'react-icons/fa';

// Sidebar entries, grouped; each one is shown only to admins holding its permission.
export const NAV = [
  { section: 'Administration', items: [
    { to: '/', label: 'Sub admins', icon: FaUserShield, permission: 'Sub Admins' },
  ] },
  { section: 'Catalogue', items: [
    { to: '/service-category', label: 'Categories', icon: FaLayerGroup, permission: 'Service Category' },
    { to: '/manage-services', label: 'Services', icon: FaToolbox, permission: 'Manage Services' },
  ] },
  { section: 'Operations', items: [
    { to: '/audits', label: 'Audits', icon: FaClipboardCheck, permission: 'Audits' },
    { to: '/bookings', label: 'Bookings', icon: FaCalendarCheck, permission: 'Bookings' },
  ] },
  { section: 'People', items: [
    { to: '/manage-vendors', label: 'Vendors', icon: FaStore, permission: 'Manage Vendors' },
    { to: '/manage-staff', label: 'Field staff', icon: FaHardHat, permission: 'Manage Staff' },
    { to: '/manage-users', label: 'Customers', icon: FaUsers, permission: 'Users' },
  ] },
];

export const firstAllowedPath = (permissions) => {
  for (const group of NAV) {
    for (const item of group.items) {
      if (permissions.includes(item.permission)) return item.to;
    }
  }
  return '/login';
};
